import request from '@/utils/request'
export function login(data) {
  return request({
    method: 'POST',
    url: '/appLogin',
    // 别忘了有参数 es6的写法 原来是data:data
    data
  })
}

